export default "__VITE_ASSET__q96ddUic__"